import React, { FC, ReactElement } from 'react';

import { IRoute } from 'types';
import { RouteContent } from 'views/components/RouteContent/RouteContent';

const GlobalRoute: FC<IRoute> = ({ component, pageTitle }): ReactElement => (
  <div>
    <RouteContent component={component} pageTitle={pageTitle} />
  </div>
);

export { GlobalRoute };
